module.exports = __webpack_public_path__ + "static/media/Paus hörnsoffa 2 rekliner micro grå bistro miljö modell 2 2023.e1fa8148.jpg";